import { handleActions } from 'redux-actions';
import {
  setIsClientAccessManagerSelectorOpen,
  setClientAccessManagerAction,
  setClientAccessManagerContacts,
  setClientAccessManagerSearchText,
} from '../actions/clientAccessManagerActions';

const defaultState = {
  isClientAccessManagerSelectorOpen: false,
  action: '',
  clientAccessManagerContacts: [],
  clientAccessManagerSearchText: '',
};

export default handleActions(
  {
    [setIsClientAccessManagerSelectorOpen](state, action) {
      return { ...state, isClientAccessManagerSelectorOpen: action.payload };
    },
    [setClientAccessManagerAction](state, action) {
      return { ...state, action: action.payload };
    },
    [setClientAccessManagerContacts](state, action) {
      return { ...state, clientAccessManagerContacts: action.payload };
    },
    [setClientAccessManagerSearchText](state, action) {
      return { ...state, clientAccessManagerSearchText: action.payload };
    },
  },
  defaultState
);
